import React from "react";
import CTdropdown from "assets/images/ct/ct-dropdown.png";
import heyLimeLogo from "assets/images/heyLimeLogo.png";
const CTHeader = ({ currentUser, toggle_dropdown = () => {} }) => {
  return (
    <div className="ct-userinfo">
      <div className="logo">
        <img alt="" src={heyLimeLogo} />{" "}
      </div>
      <div className="user-details">
        <img src={currentUser?.picture} alt="user" />
        <p>{currentUser?.userName} </p>
        <img
          className="dropdown-logo "
          alt=""
          src={CTdropdown}
          onClick={toggle_dropdown}
        />
      </div>
    </div>
  );
};

export default CTHeader;
